import {
  Stack, SimpleGrid, Skeleton,
} from '@mantine/core';
import { IconReceipt } from '@tabler/icons-react';
import PageHeader from '@/components/PageHeader';
import StatCard from '@/components/StatCard';
import EmptyState from '@/components/EmptyState';
import { useLoyaltyPoints } from '@/hooks/usePortalApi';

export default function LoyaltyRewards() {
  const { data, isLoading } = useLoyaltyPoints();

  return (
    <Stack gap="lg">
      <PageHeader title="Loyalty Rewards" description="View your loyalty points and rewards" />
      {isLoading ? (
        <SimpleGrid cols={{ base: 1, sm: 2, lg: 3 }}>
          {[...Array(3)].map((_, i) => <Skeleton key={i} height={120} radius="md" />)}
        </SimpleGrid>
      ) : !data ? (
        <EmptyState icon={<IconReceipt size={30} />} title="No loyalty data" description="No loyalty points data available" />
      ) : (
        <SimpleGrid cols={{ base: 1, sm: 2, lg: 3 }}>
          <StatCard
            title="Total Points"
            value={String(data.total_points ?? 0)}
            icon={<IconReceipt size={24} />}
          />
          <StatCard
            title="Available Points"
            value={String(data.available_points ?? 0)}
            icon={<IconReceipt size={24} />}
          />
          <StatCard
            title="Points Redeemed"
            value={String(data.redeemed_points ?? 0)}
            icon={<IconReceipt size={24} />}
          />
          <StatCard
            title="Current Tier"
            value={data.tier ?? 'Standard'}
            icon={<IconReceipt size={24} />}
          />
          <StatCard
            title="Points Expiring Soon"
            value={String(data.expiring_points ?? 0)}
            icon={<IconReceipt size={24} />}
          />
          <StatCard
            title="Lifetime Points"
            value={String(data.lifetime_points ?? 0)}
            icon={<IconReceipt size={24} />}
          />
        </SimpleGrid>
      )}
    </Stack>
  );
}
